"use strict";

import $ from "jquery";

class SearchFilters
{
    constructor(filters, options) {
        this.options = Object.assign({}, {
            onChange: null
        }, options);

        // Required.
        if ((this.filters = $(filters)).length < 1) {
            return;
        }

        this.listen();
    }

    listen() {
        this.filters.each((i, filter) => {
            const $filter = $(filter);

            $filter.is("input[type='checkbox']") && $filter.bind("change", (event) => {
                let value, $label, $i;

                if ($filter.is("input[type='checkbox']")) {
                    $label = $filter.closest("label").first();
                    $i = $label.find("i");

                    $label[($filter[0].checked ? "add" : "remove") + "Class"](
                        "active"
                    );

                    if ($i.hasClass("vsicons-android-checkbox-outline") ||
                        $i.hasClass("vsicons-android-checkbox-outline-blank")) {
                        $i[($filter[0].checked ? "add" : "remove") + "Class"](
                            "vsicons-android-checkbox-outline"
                        );

                        $i[($filter[0].checked ? "remove" : "add") + "Class"](
                            "vsicons-android-checkbox-outline-blank"
                        );
                    }
                }

                if ($filter.data("isarray") === "no") {
                    value = $filter.val();
                } else {
                    value = [$filter.val()];
                }

                if (typeof this.options.onChange === "function") {
                    // Fire onChange callback
                    this.options.onChange(
                        $filter.attr("name"),
                        value,
                        $filter.data("filter-reverse") ?
                            $filter[0].checked : !$filter[0].checked
                    );
                }
            });
        });
    }
}

export default SearchFilters;
